import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import "devextreme-react/text-area";
import { Button } from "devextreme-react";
import UserInfo from "../../UserInfo";
import { inserirOuAtualizar, criarConfiguracaoCndDs } from "../../DataSources";
import HtmlEditor, { Toolbar, Item } from "devextreme-react/html-editor";
import ShowError from "../../AppServices";

let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  prefeituraId: undefined,
  descricao: "",
  validade: undefined,
  texto: "",
  naturezaStr: "",
  tipoCadastroStr: "",
};

export default class ConfiguracaoCndForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = { ...(_cadastroCorrente || template) };
    template.prefeituraId = UserInfo.getPrefeitura();
    this.configuracaoCndDs = criarConfiguracaoCndDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;
    this.notesOptions = { height: 140, border: true };
    this.sizeValues = ["8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt"];
    this.fontValues = [
      "Arial",
      "Courier New",
      "Georgia",
      "Impact",
      "Lucida Console",
      "Tahoma",
      "Times New Roman",
      "Verdana",
    ];
    this.headerValues = [false, 1, 2, 3, 4, 5];
    this.enabled = {
      enabled: true,
    };
    this.valueChangedOnText = this.valueChangedOnText.bind(this);
  }

  componentDidMount() {
    if (_cadastroCorrente === undefined) {
      if (this.props.match.params.id !== undefined) {
        this.configuracaoCndDs
          .byKey(this.props.match.params.id)
          .then((data) => {
            if (data == undefined) {
              notify("CND não encontrado.", "error");
              this.props.history.push("/tipocertidao");
            }
            this.setState(data);
          })
          .catch((error) => {
            ShowError(error.response.data);
            notify(error, "error", 2000);
            this.props.history.goBack();
          });
      }
    } else {
      this.setState({ ...template });
    }
    _cancelando = false;
  }

  componentWillUnmount() {
    if (this.props.match.params.id !== undefined) {
      _cadastroCorrente = _cancelando ? undefined : this.state;
    }
  }

  render() {
    const tiposNaturezaStr = [
      { id: "P", descricao: "Positiva" },
      { id: "N", descricao: "Negativa" },
    ];

    const naturezaStrOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: tiposNaturezaStr,
      valueExpr: "id",
      displayExpr: "descricao",
    };

    const tiposCadastroStr = [
      { id: "E", descricao: "Empresa" },
      { id: "I", descricao: "Imóvel" },
      { id: "C", descricao: "Contribuinte" },
    ];

    const cadastroStrOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: tiposCadastroStr,
      valueExpr: "id",
      displayExpr: "descricao",
    };

    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.state} colCount={3}>
            <GroupItem caption="CONFIGURAÇÃO CND" colSpan={3} colCount={3}>
              <SimpleItem dataField={"validade"}>
                <Label text="Validade" />
              </SimpleItem>
              <SimpleItem
                dataField={"naturezaStr"}
                editorType={"dxLookup"}
                editorOptions={naturezaStrOptions}
              >
                <Label text="Natureza da Certidão" />
              </SimpleItem>
              <SimpleItem
                dataField={"tipoCadastroStr"}
                editorType={"dxLookup"}
                editorOptions={cadastroStrOptions}
              >
                <Label text="Tipo da Certidão" />
              </SimpleItem>
            </GroupItem>
            <GroupItem colCount={1} colSpan={3}>
              <SimpleItem dataField={"descricao"} editorType={"dxTextArea"}>
                <Label text="Descrição" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="TEXTO" colSpan={3} colCount={1}>
              <HtmlEditor
                height={"300px"}
                mediaResizing={this.enabled}
                value={this.state.texto}
                onValueChanged={this.valueChangedOnText}
              >
                <Toolbar>
                  <Item formatName="undo" />
                  <Item formatName="redo" />
                  <Item formatName="separator" />
                  <Item formatName="size" formatValues={this.sizeValues} />
                  <Item formatName="font" formatValues={this.fontValues} />
                  <Item formatName="separator" />
                  <Item formatName="bold" />
                  <Item formatName="italic" />
                  <Item formatName="strike" />
                  <Item formatName="underline" />
                  <Item formatName="separator" />
                  <Item formatName="alignLeft" />
                  <Item formatName="alignCenter" />
                  <Item formatName="alignRight" />
                  <Item formatName="alignJustify" />
                  <Item formatName="separator" />
                  <Item formatName="header" formatValues={this.headerValues} />
                  <Item formatName="separator" />
                  <Item formatName="orderedList" />
                  <Item formatName="bulletList" />
                  <Item formatName="separator" />
                  <Item formatName="color" />
                  <Item formatName="background" />
                  <Item formatName="separator" />
                  <Item formatName="link" />
                  <Item formatName="image" />
                  <Item formatName="separator" />
                  <Item formatName="clear" />
                  <Item formatName="codeBlock" />
                  <Item formatName="blockquote" />
                </Toolbar>
              </HtmlEditor>
            </GroupItem>
          </Form>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Salvar"
                type="success"
                onClick={this.ok}
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Button text="Cancelar" onClick={this.cancel} width={120} />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  valueChangedOnText(e) {
    this.setState({
      texto: e.value,
    });
  }

  ok() {
    const entidade = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };
    inserirOuAtualizar(this.configuracaoCndDs, entidade)
      .then(
        function () {
          _cadastroCorrente = undefined;
          _cancelando = true;
          notify("Configuração CND cadastrada com sucesso.", "success");
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
